module.exports = (__webpack_require__(2))(5);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/View.js from dll-reference girder_plugin_slicer_cli_web
// module id = 8
// module chunks = 0